import type { WidgetDefinition } from '../WidgetDefinition';
import { faUsersBetweenLines } from '@fortawesome/pro-regular-svg-icons/faUsersBetweenLines';
import type { AccountsWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import type { AccountsWidgetViewModel } from 'src/store/types';

class AccountsWidgetDefinition implements WidgetDefinition<AccountsWidgetViewModel, AccountsWidgetModel> {
    type = 'accounts' as const;
    nameKey = 'widgets::accounts::name' as const;
    roles = ['widgets::accounts'];
    icon = faUsersBetweenLines;
    category = 'widgets::categories::risk' as const;
    /**
     * Converts an Accounts widget from contract model to view model
     */
    toViewModel(widget: AccountsWidgetModel): AccountsWidgetViewModel {
        return widget;
    }

    /**
     * Converts an Accounts widget from view model to contract model
     */
    toContractModel(widget: AccountsWidgetViewModel): AccountsWidgetModel {
        return widget;
    }
}

export const accountsWidgetDefinition = new AccountsWidgetDefinition();
